import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Routes,
} from "react-router-dom";
import PaymentSide from "./screens/user/paymentSide";
import WelcomeToSmartPay from "./screens/landingPage/welcomeToSmartPay";
import MerchantLogin from "./screens/merchant/merchantLogin";
import MerchantInvoice from "./screens/merchant/merchantInvoice";
import NotFound from "./screens/notFound";
import MerchantLayout from "./layout/merchantLayout";
import MerchantVatMerchant from "./screens/merchant/merchantVatMerchant";
import MerchantCheckInvoice from "./screens/merchant/merchantCheckInvoice";
import MerchantDashboard from "./screens/merchant/merchantDashboard";
import { LoadingProvider } from "./context/loadingContext";
import Loader from "./components/other/loader";
import MerchantIncome from "./screens/merchant/merchantIncome";
import MerchantVatHistory from "./screens/merchant/merchantVatHistory";
import AdminLayout from "./layout/adminLayout";
import AdminDashboard from "./screens/admin/dashboard";
import AdminLogin from "./screens/admin/login";
import Merchants from "./screens/admin/merchant";
import ProductTypeList from "./screens/admin/reference/productType";
import BankCodeList from "./screens/admin/reference/bankCode";
import AdminInvoice from "./screens/admin/invoice";
import VatZeroGoods from "./screens/admin/reference/vatZeroGoods";
import VatFreeProducts from "./screens/admin/reference/vatFreeProducts";
import { AdminProvider } from "./context/adminContext";
import { MerchantProvider } from "./context/merchantContext";
import XpayPayment from "screens/merchant/xpayPayment";
import BillingDoc from "screens/merchant/billingDoc";
import MerchantActionLog from "screens/merchant/merchantActionLog";
import BankTransactionLog from "screens/admin/bankTransactionLog";
import SignUp from "screens/signUp";
import ResetPasswordScreen from "screens/landingPage/resetPassword";
import RemoveTrailingSlash from "screens/removeTrailingSlash";
import FunctionCall from "screens/admin/functionCall";
import PosList from "screens/admin/pos";
import SubMerchantIncome from "screens/merchant/subMerchantIncome";
import MerchantList from "screens/admin/merchantList";
import MerchantImpersonate from "screens/merchant/merchantImpersonate";
import Reconciliation from "screens/admin/reconciliation";
import MerchantFeeShareRule from "screens/merchant/merchantFeeShareRule";
import MerchantSplitHistory from "screens/merchant/merchantSplitHistory";

function App() {
  return (
    <LoadingProvider>
      <MerchantProvider>
        <AdminProvider>
          <Loader />
          <Router>
            <RemoveTrailingSlash />

            <Routes>
              <Route>
                <Route path="/" element={<WelcomeToSmartPay />}></Route>
                <Route path="/merchant" element={<MerchantLogin />}></Route>
                <Route path="/signUp" element={<SignUp />}></Route>
                <Route
                  path="/reset-password"
                  element={<ResetPasswordScreen />}
                ></Route>
                <Route path="/admin" element={<AdminLogin />}></Route>
                <Route path="/invoice" element={<PaymentSide />}></Route>
                <Route
                  path="/merchant-impersonate"
                  element={<MerchantImpersonate />}
                ></Route>
              </Route>
              <Route element={<AdminLayout />}>
                <Route path="/pos" element={<PosList />}></Route>
                <Route path="/functionCall" element={<FunctionCall />}></Route>
                <Route
                  path="/bankTransactionLog/:account"
                  element={<BankTransactionLog />}
                ></Route>
                <Route
                  path="/adminDashboard"
                  element={<AdminDashboard />}
                ></Route>
                <Route
                  path="/adminMerchants/:id"
                  element={<Merchants />}
                ></Route>
                <Route
                  path="/adminMerchants"
                  element={<MerchantList />}
                ></Route>
                <Route
                  path="/productType"
                  element={<ProductTypeList />}
                ></Route>
                <Route path="/bankCode" element={<BankCodeList />}></Route>
                <Route path="/vatZeroGoods" element={<VatZeroGoods />}></Route>
                <Route
                  path="/vatFreeGoods"
                  element={<VatFreeProducts />}
                ></Route>
                <Route path="/adminInvoice" element={<AdminInvoice />}></Route>
                <Route path="/reconciliation" element={<Reconciliation />}></Route>
              </Route>
              <Route element={<MerchantLayout />}>
                <Route
                  path="/merchantDashboard"
                  element={<MerchantDashboard />}
                ></Route>
                <Route
                  path="/merchantInvoice"
                  element={<MerchantInvoice />}
                ></Route>
                <Route path="/xpayPayment" element={<XpayPayment />}></Route>
                <Route path="/xpayDoc" element={<BillingDoc />}></Route>

                <Route path="/vatLog" element={<MerchantVatHistory />}></Route>
                <Route
                  path="/merchantActionLog"
                  element={<MerchantActionLog />}
                ></Route>

                <Route
                  path="/merchantIncome"
                  element={<MerchantIncome />}
                ></Route>
                <Route
                  path="/subMerchantIncome"
                  element={<SubMerchantIncome />}
                ></Route>
                <Route
                  path="/merchantInvoiceList"
                  element={<MerchantCheckInvoice />}
                ></Route>
                <Route
                  path="/merchantVat"
                  element={<MerchantVatMerchant />}
                ></Route>
                <Route
                  path="/merchantFeeShareRule"
                  element={<MerchantFeeShareRule />}
                ></Route>
                <Route
                  path="/merchantSplitHistory"
                  element={<MerchantSplitHistory />}
                ></Route>
              </Route>
              <Route path="*" element={<NotFound />}></Route>
            </Routes>
          </Router>
        </AdminProvider>
      </MerchantProvider>
    </LoadingProvider>
  );
}

export default App;
